import React from 'react';
import { Toaster } from 'react-hot-toast';
import '../../Complaint.css';
import { FaPlus, FaExclamation } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CommonContainer.css";

const CommonContainer = ({ heading, icon, subHeading, buttonText, onButtonClick, children }) => {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 m-0 p-0">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="card w-100 shadow-lg border-0 m-0 p-0" style={{ minHeight: "125vh" }}>
        <div className="card-body m-0">

          {/* Header section */}
          <div className="d-flex  flex-sm-row align-items-sm-center  justify-content-between mb-3 gap-3">

            {/* Heading and subheading inline */}
            <div className="d-flex align-items-center flex-wrap gap-2">
              <div>{icon}</div>
              <h4 className="m-0">{heading}</h4>
              {/* {subHeading && (
                <span className="text-muted small m-0" style={{ lineHeight: '1.2' }}>
                  {subHeading}
                </span>
              )} */}
            </div>

            {/* Add button */}
            <div className="d-flex align-items-center gap-2">
              {buttonText && (
                <button className="btn custom-sumbitbtn d-flex align-items-center common-container-btn" onClick={onButtonClick}>
                  <FaPlus className="me-md-2" />
                  {buttonText}
                </button>
              )}
            </div>

          </div>

          {/* Body content */}
          <div>
            {children}
          </div>

        </div>
      </div>
    </div>
  );
};

export default CommonContainer;
